export default "__VITE_ASSET__Bm1Ml3NW__"